package org.lennycodes.hldi.pages.admin
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.lennycodes.hldi.data.Event

@Composable
fun ConfirmDeleteEvent(
    event: Event,
    onDismiss: () -> Unit,
    onConfirm: () -> Unit
) {

    var isLoading by remember {
        mutableStateOf(false)
    }


    Div(
        attrs = Modifier
            .padding(16.px)
            .then(DialogBackdropStyle.toModifier())
            .toAttrs {

                onClick {
                    if (!isLoading) {
                        onDismiss()
                    }
                }

            }
    ) {


        Div(
            attrs = Modifier
                .padding(32.px)
                .then(DialogCardStyle.toModifier())
                .toAttrs {

                    onClick {
                        it.stopPropagation()
                    }

                }
        ) {


            H3(
                attrs = DialogTitleStyle.toAttrs()
            ) {

                Text("Delete Event")

            }


            P(
                attrs = DialogSubtitleStyle.toAttrs()
            ) {

                Text(
                    "Are you sure you want to delete \"${event.title}\"?"
                )

            }


            Row(
                modifier = DialogActionsRowStyle.toModifier(),
                horizontalArrangement = Arrangement.spacedBy(12.px)
            ) {


                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .then(CancelButtonStyle.toModifier()),

                    onClick = {
                        onDismiss()
                    }

                ){

                    Text("Cancel")

                }



                Button(

                    enabled = !isLoading,

                    modifier = Modifier
                        .padding(11.px,22.px)
                        .backgroundColor(
                            com.varabyte.kobweb.compose.ui.graphics.Color.rgb(
                                220,
                                53,
                                69
                            )
                        )
                        .color(
                            Color.white
                        ),

                    onClick = {

                        isLoading = true

                        onConfirm()

                    }

                ){

                    Text(
                        if(isLoading)
                            "Deleting..."
                        else
                            "Delete"
                    )

                }


            }

        }

    }

}